import React from "react";
import {
    Box,
    Typography,
    Avatar,
    Paper,
    Divider,
    Stack,
    IconButton,
} from "@mui/material";
import AttachmentIcon from "@mui/icons-material/AttachFile";
import DownloadIcon from "@mui/icons-material/Download";
import moment from "moment";
import CommentAttachments from "./commentAttachments";
import { useGetChangeTrackerCommentsQuery } from "store/slices/apis/changeTrackerComment";


function stringToColor(string) {
    let hash = 0;
    let i;

    for (i = 0; i < string?.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
}

function stringAvatar(name) {
    return {
        sx: {
            bgcolor: stringToColor(name),
        },
        children: `${name?.split(' ')?.[0]?.[0]}`,
    };
}

const ChangeCommentList = (props) => {
    const { data, refetchTrigger } = props;

    const { data: apiResponse, isLoading, refetch } = useGetChangeTrackerCommentsQuery({
        changeId: data?.changeId
    });

    // React.useEffect(() => {
    //     if (refetchTrigger) {
    //         refetch();
    //     }
    // }, [refetchTrigger, refetch]);


    const commentsToDisplay = apiResponse?.data && apiResponse.data.length > 0 
        ? apiResponse.data 
        : [];

    // const commentsToDisplay = dummyComments

    return (
        <Box
            sx={{
                mx: "auto",
                display: "flex",
                flexDirection: "column",
                gap: 2,
            }}
        >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Comments & Attachments
            </Typography>

            {commentsToDisplay.map((comment, index) => (
                <Paper
                    key={comment.id || index}
                    elevation={0}
                    sx={{
                        p: 2,
                        border: "1px solid #e0e0e0",
                        borderRadius: 2,
                        backgroundColor: "#fafafa",
                    }}
                >
                    {/* Header */}
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Avatar {...stringAvatar(comment?.commentBy)} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                {comment?.commentBy}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                {moment(comment?.createdDate)?.format('LLL')}
                            </Typography>
                        </Box>
                    </Stack>

                    <Typography
                        variant="body2"
                        sx={{ mt: 1.5, color: "#333", lineHeight: 1.6 }}
                    >
                        {comment?.comment}
                    </Typography>


                    <CommentAttachments comment={comment} />
                </Paper>
            ))}
        </Box>
    );
};

export default ChangeCommentList;